import { IBookingCalendarStore } from '../../index'
import { IToggleServicesModal } from '../../../../actions/bookingCalendar/reservationModal/toggleServicesModal'

export default function(
  state: IBookingCalendarStore,
  action: IToggleServicesModal,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      servicesModal: {
        ...state.reservationModal.servicesModal,
        isLoading: !action.toggle
          ? false
          : state.reservationModal.servicesModal.isLoading,
        open: action.toggle,
      },
    },
  }
}
